import {
  ActivityTab,
  MediaTab,
  OverviewTab,
  PublisherTab,
  ReleasesTab,
  SystemTab,
} from './tabs';
import type { SuperDappTabDefinition } from './types';

export const superDappTabs: SuperDappTabDefinition[] = [
  { key: 'overview', label: 'Overview', component: OverviewTab },
  { key: 'releases', label: 'Releases', component: ReleasesTab },
  { key: 'media', label: 'Media', component: MediaTab },
  { key: 'activity', label: 'Activity', component: ActivityTab },
  { key: 'publisher', label: 'Publisher', component: PublisherTab },
  { key: 'system', label: 'System', component: SystemTab },
];
